/* eslint-disable @typescript-eslint/no-empty-function */
import i18n, { BackendModule, ReadCallback } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use({
    type: 'backend',
    init() {},
    read(language: string, namespace: string, callback: ReadCallback) {
      import(`../assets/locales/${language}/${namespace}.json`)
        .then(resources => {
          callback(null, resources.default);
        })
        .catch(error => {
          callback(error, false);
        });
    },
    create() {},
    readMulti() {},
    save() {},
  } as BackendModule)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
    initImmediate: false,
    ns: [],
    defaultNS: 'common',
    load: 'languageOnly',
    backend: {},
  });

export default i18n;
